import React from 'react'
import PropTypes from 'prop-types'

import { GlgTooltip } from 'Shared/components'

const LeagueRoundsTooltipChip = ({ league }) => {
  if (!league?.first_round?.playAt || !league?.last_round?.playAt) {
    return null
  }

  const text = window.I18n.t(
    'clone_leagues_sessions.leagues_search.first_last_round_tooltip',
    { first_round: league?.first_round?.playAt, last_round: league?.last_round?.playAt },
  )

  return (<GlgTooltip tooltip={text}>
   <span className='cls-lb-rounds-tooltip-chip'>
     <span>R1</span>
     <span>{league?.first_round?.playAt}</span>
   </span>
  </GlgTooltip>)
}

LeagueRoundsTooltipChip.propTypes = {
  league: PropTypes.shape({
    first_round: PropTypes.shape({
      playAt: PropTypes.string,
    }),
    last_round: PropTypes.shape({
      playAt: PropTypes.string,
    }),
  }),
}
export default LeagueRoundsTooltipChip
